import commonStore from "./common/store";
import projectStore from "./features/programme/store/programme.store";
import authStore from "./store/modules/auth";

import { createStore } from "vuex";

const store = createStore({
  modules: {
    common: commonStore,
    project: projectStore,
    auth: authStore,
  },
});

export default store;